import { createElement, useState, useEffect } from 'react';
import './index.scss';
import { Select as NextSelect, Drawer, NumberPicker, Button } from '@alifd/next';
const CustomSelect = ({ popType, selectType = 'string', dataList = [], value, prefix, dialogTitle = '请选择', btnText = '确认', options, onChange, ...otherProps }) => {
    const [visible, setVisible] = useState(false);
    const [tempValue, setTempValue] = useState(value);
    const [innerValue, setInnerValue] = useState(value);
    useEffect(() => {
        setTempValue(value);
        setInnerValue(value);
    }, [value]);
    const _otherProps = otherProps || {};
    const restProps = otherProps || {};
    const committedValue = innerValue;
    const finalDataSource = options?.length ? options : dataList;
    const handleClick = () => {
        if (popType === 'dialog') {
            setTempValue(committedValue);
            setVisible(true);
        }
    };
    const handleOk = () => {
        setInnerValue(tempValue);
        onChange?.(tempValue);
        setVisible(false);
    };
    const handleCancel = () => {
        setTempValue(committedValue);
        setVisible(false);
    };
    const handleSelect = (selectedValue) => {
        setTempValue(selectedValue);
        if (popType === 'dialog') {
            return;
        }
        setInnerValue(selectedValue);
        onChange?.(selectedValue);
    };
    const handleBottomChange = handleSelect;
    const renderContent = () => {
        if (selectType === 'number') {
            return createElement(NumberPicker, {
                value: tempValue,
                onChange: handleSelect,
                style: { width: '100%' },
            });
        }
        if (selectType === 'color') {
            return (createElement("div", { className: "select-options color-options" }, finalDataSource.map((item) => (createElement("div", { key: item.value, className: `select-option color-option ${tempValue === item.value ? 'selected' : ''}`, onClick: () => handleSelect(item.value), style: { backgroundColor: item.value } },
                createElement("span", { className: "color-label" }, item.label))))));
        }
        return (createElement("div", { className: "select-options" }, finalDataSource.map((item) => (createElement("div", { key: item.value, className: `select-option ${tempValue === item.value ? 'selected' : ''}`, onClick: () => handleSelect(item.value) }, item.label)))));
    };
    return (createElement("div", { className: "custom-select", ..._otherProps }, popType === 'bottom' ? (createElement(NextSelect, {
        ...restProps,
        label: prefix,
        value: committedValue,
        dataSource: finalDataSource,
        onChange: handleBottomChange,
    })) : popType === 'normal' ? (createElement("div", { className: "select-normal" },
        prefix && createElement("span", { className: "prefix" }, prefix),
        renderContent())) : (createElement("div", null,
        createElement("div", { className: "select-trigger", onClick: handleClick },
            prefix && createElement("span", { className: "prefix" }, prefix),
            createElement("span", { className: "value" }, selectType === 'string'
                ? finalDataSource.find((item) => item.value === committedValue)?.label || '请选择'
                : committedValue || '请选择')),
        createElement(Drawer, {
            placement: 'bottom',
            visible,
            title: dialogTitle,
            onClose: handleCancel,
            footerAlign: 'center',
        }, renderContent(), createElement(Button, {
            className: 'select-btn',
            onClick: handleOk,
        }, btnText))))));
};
CustomSelect.displayName = 'CustomSelect';
export default CustomSelect;
